export function videoIframe() {
    let videoHolder = $("#video-section");

    videoHolder.on("click", ".play-button, .video-content", function (e) {
        e.preventDefault();
        if(!videoHolder.hasClass('video-play')){
            var _video = '';
            var _url = $('#btn-play').attr("href");
    
            if (_url.includes(location.host)) {
    
                _video = '<video class="video-block" width="1570" height="883" autoplay="true" autobuffer="" controls="1"><source type="video/mp4" src="' + _url + '"></video>';
    
            } else {
    
                var commandPlay = {
                    "event": "command",
                    "func": "playVideo"
                };
                _url = _url.replace("watch?v=", "embed/");
                var src = _url + '?enablejsapi=1&autoplay=1';
                _video = '<iframe class="video-block"  width="1570" height="883"  src="' + src + '" frameborder="0" allow="autoplay" allowfullscreen></iframe>';
    
            }
    
            videoHolder.find('.video-content').append(_video);
            videoHolder.addClass('video-play');
        }

        /*
         if (!videoPopup.hasClass("video-play")) {
         videoPopup.find('iframe')[0].contentWindow.postMessage(JSON.stringify(commandPlay), "*");
         videoPopup.addClass("video-play");
         }
         */


    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/video.js